/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Period to which the limit applies.
 *
 * | Value                      | Description                                       |
 * |----------------------------|---------------------------------------------------|
 * | `DAILY`                    | The defined limit is valid for a day.             |
 * | `PER_ORDER`                | The defined limit is valid for every single order |
 *
 */
export enum AccountLimitPeriodicity {
    DAILY = 'DAILY',
    PER_ORDER = 'PER_ORDER',
}
